import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  root: {
    [breakpoints.down(640)]: {
      paddingBottom: '25px !important',
    },
  },
}));
